interface TokenMap {
	[key: string]: string,
	a: string;
	c: string;
	s: string;
	z: string;
}

interface AddressData {
	[key: string]: string | null
	address: string;
	city: string;
	state: string;
	zip: string;
}

export default function( { address, city, state, zip }: AddressData, token: string = "a, c, s z" ): string {
	const tokenMap: TokenMap = {
		a: "address",
		c: "city",
		s: "state",
		z: "zip"
	};

	const formatRegex = new RegExp( Object.keys( tokenMap ).join( "|" ), "gi" );

	const addressData: AddressData = {
		address,
		city,
		state,
		zip
	};

	return token.replace(
		formatRegex,
		matched => {
			if ( addressData.hasOwnProperty( tokenMap[matched] )
				&& addressData[tokenMap[matched]]
			) {
				return ( addressData[tokenMap[matched]] as string );
			}

			return matched;
		}
	);
}
